import { useState } from 'react';

type Revenu = 'tres-modeste' | 'modeste' | 'intermediaire' | 'superieur';
type Projet = 'pac-air-air' | 'pac-air-eau' | 'photovoltaique' | 'solaire-combine' | 'isolation-combles' | 'isolation-sous-sol' | 'ite';

interface SimResult {
  maPrimeRenov: number;
  cee: number;
  tva: string;
  total: number;
  note: string;
}

const SIMS: Record<Projet, Record<Revenu, SimResult>> = {
  'pac-air-air': {
    'tres-modeste':  { maPrimeRenov: 5000, cee: 1200, tva: '5,5 %', total: 6200, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'modeste':       { maPrimeRenov: 4000, cee: 1200, tva: '5,5 %', total: 5200, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'intermediaire': { maPrimeRenov: 2500, cee: 1200, tva: '10 %',  total: 3700, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'superieur':     { maPrimeRenov: 0,    cee: 1200, tva: '10 %',  total: 1200, note: 'MaPrimeRénov\' non disponible pour ce niveau de revenus.' },
  },
  'pac-air-eau': {
    'tres-modeste':  { maPrimeRenov: 10000, cee: 2500, tva: '5,5 %', total: 12500, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'modeste':       { maPrimeRenov: 8000,  cee: 2500, tva: '5,5 %', total: 10500, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'intermediaire': { maPrimeRenov: 5000,  cee: 2500, tva: '10 %',  total: 7500,  note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'superieur':     { maPrimeRenov: 0,     cee: 2500, tva: '10 %',  total: 2500,  note: 'MaPrimeRénov\' non disponible pour ce niveau de revenus.' },
  },
  'photovoltaique': {
    'tres-modeste':  { maPrimeRenov: 0, cee: 0, tva: '10 %', total: 0, note: 'Pas d\'aide directe — TVA réduite à 10 % applicable. Prime à l\'autoconsommation selon puissance installée (env. 300–1 000 €/kWc via EDF OA).' },
    'modeste':       { maPrimeRenov: 0, cee: 0, tva: '10 %', total: 0, note: 'Pas d\'aide directe — TVA réduite à 10 % applicable. Prime à l\'autoconsommation selon puissance installée (env. 300–1 000 €/kWc via EDF OA).' },
    'intermediaire': { maPrimeRenov: 0, cee: 0, tva: '10 %', total: 0, note: 'Pas d\'aide directe — TVA réduite à 10 % applicable. Prime à l\'autoconsommation selon puissance installée (env. 300–1 000 €/kWc via EDF OA).' },
    'superieur':     { maPrimeRenov: 0, cee: 0, tva: '10 %', total: 0, note: 'Pas d\'aide directe — TVA réduite à 10 % applicable. Prime à l\'autoconsommation selon puissance installée (env. 300–1 000 €/kWc via EDF OA).' },
  },
  'solaire-combine': {
    'tres-modeste':  { maPrimeRenov: 15000, cee: 2000, tva: '5,5 %', total: 17000, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'modeste':       { maPrimeRenov: 12000, cee: 2000, tva: '5,5 %', total: 14000, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'intermediaire': { maPrimeRenov: 8000,  cee: 2000, tva: '10 %',  total: 10000, note: 'Estimation indicative, sous réserve de validation ANAH.' },
    'superieur':     { maPrimeRenov: 0,     cee: 2000, tva: '10 %',  total: 2000,  note: 'MaPrimeRénov\' non disponible pour ce niveau de revenus.' },
  },
  'isolation-combles': {
    'tres-modeste':  { maPrimeRenov: 7000, cee: 1500, tva: '5,5 %', total: 8500, note: 'Isolation des combles perdus ou aménagés. Estimation indicative.' },
    'modeste':       { maPrimeRenov: 5500, cee: 1500, tva: '5,5 %', total: 7000, note: 'Isolation des combles perdus ou aménagés. Estimation indicative.' },
    'intermediaire': { maPrimeRenov: 3000, cee: 1500, tva: '10 %',  total: 4500, note: 'Isolation des combles perdus ou aménagés. Estimation indicative.' },
    'superieur':     { maPrimeRenov: 0,    cee: 1500, tva: '10 %',  total: 1500, note: 'MaPrimeRénov\' non disponible pour ce niveau de revenus.' },
  },
  'isolation-sous-sol': {
    'tres-modeste':  { maPrimeRenov: 5000, cee: 1200, tva: '5,5 %', total: 6200, note: 'Isolation du plancher bas (sous-sol, vide sanitaire). Estimation indicative.' },
    'modeste':       { maPrimeRenov: 4000, cee: 1200, tva: '5,5 %', total: 5200, note: 'Isolation du plancher bas (sous-sol, vide sanitaire). Estimation indicative.' },
    'intermediaire': { maPrimeRenov: 2000, cee: 1200, tva: '10 %',  total: 3200, note: 'Isolation du plancher bas (sous-sol, vide sanitaire). Estimation indicative.' },
    'superieur':     { maPrimeRenov: 0,    cee: 1200, tva: '10 %',  total: 1200, note: 'MaPrimeRénov\' non disponible pour ce niveau de revenus.' },
  },
  'ite': {
    'tres-modeste':  { maPrimeRenov: 15000, cee: 3000, tva: '5,5 %', total: 18000, note: 'Isolation Thermique par l\'Extérieur (ITE). Estimation indicative selon surface.' },
    'modeste':       { maPrimeRenov: 12000, cee: 3000, tva: '5,5 %', total: 15000, note: 'Isolation Thermique par l\'Extérieur (ITE). Estimation indicative selon surface.' },
    'intermediaire': { maPrimeRenov: 7000,  cee: 3000, tva: '10 %',  total: 10000, note: 'Isolation Thermique par l\'Extérieur (ITE). Estimation indicative selon surface.' },
    'superieur':     { maPrimeRenov: 0,     cee: 3000, tva: '10 %',  total: 3000,  note: 'MaPrimeRénov\' non disponible pour ce niveau de revenus.' },
  },
};

const projetLabels: Record<Projet, string> = {
  'pac-air-air':        'PAC air/air',
  'pac-air-eau':        'PAC air/eau',
  'photovoltaique':     'Panneaux solaires',
  'solaire-combine':    'Solaire combiné',
  'isolation-combles':  'Isolation combles',
  'isolation-sous-sol': 'Isolation sous-sol',
  'ite':                'Isolation extérieure (ITE)',
};

const projetIcons: Record<Projet, string> = {
  'pac-air-air':        'ri-temp-hot-line',
  'pac-air-eau':        'ri-drop-line',
  'photovoltaique':     'ri-sun-line',
  'solaire-combine':    'ri-contrast-2-line',
  'isolation-combles':  'ri-home-4-line',
  'isolation-sous-sol': 'ri-building-line',
  'ite':                'ri-layout-masonry-line',
};

const revenuLabels: Record<Revenu, string> = {
  'tres-modeste':  'Très modestes (- de 21 805 €/an)',
  'modeste':       'Modestes (21 805 – 33 453 €/an)',
  'intermediaire': 'Intermédiaires (33 453 – 51 281 €/an)',
  'superieur':     'Supérieurs (+ de 51 281 €/an)',
};

const aides = [
  {
    logo: 'ri-government-line',
    color: 'bg-orange-50 border-orange-200',
    iconColor: 'text-orange-500 bg-orange-100',
    tag: 'Prime directe',
    tagColor: 'bg-orange-100 text-orange-700',
    title: 'MaPrimeRénov\'',
    amount: 'Jusqu\'à 15 000 €',
    desc: 'Prime versée directement par l\'ANAH pour financer vos travaux de rénovation énergétique. Accessible à tous les propriétaires, le montant varie selon vos revenus.',
    conditions: ['Propriétaire occupant ou bailleur', 'Logement construit avant 2000', 'Artisan RGE obligatoire', 'Revenus pris en compte'],
    link: 'https://www.maprimerenov.gouv.fr'
  },
  {
    logo: 'ri-flashlight-line',
    color: 'bg-teal-50 border-teal-200',
    iconColor: 'text-teal-600 bg-teal-100',
    tag: 'Coup de pouce énergie',
    tagColor: 'bg-teal-100 text-teal-700',
    title: 'Certificats d\'Économies d\'Énergie (CEE)',
    amount: 'Jusqu\'à 3 000 €',
    desc: 'Les entreprises énergétiques financent vos travaux via les CEE. Cumulable avec MaPrimeRénov\', sans condition de revenus.',
    conditions: ['Cumulable avec MaPrimeRénov\'', 'Sans conditions de revenus', 'Artisan RGE obligatoire', 'Travaux éligibles listés'],
    link: '#contact'
  },
  {
    logo: 'ri-percent-line',
    color: 'bg-emerald-50 border-emerald-200',
    iconColor: 'text-emerald-600 bg-emerald-100',
    tag: 'Avantage fiscal',
    tagColor: 'bg-emerald-100 text-emerald-700',
    title: 'TVA réduite',
    amount: '5,5 % ou 10 %',
    desc: 'TVA à taux réduit sur la fourniture et la pose de vos équipements. S\'applique automatiquement sur votre devis AIRPURE.',
    conditions: ['Logement achevé depuis + de 2 ans', 'Résidence principale ou secondaire', 'Pas de plafond de revenus', 'Applicable automatiquement'],
    link: '#contact'
  },
  {
    logo: 'ri-bank-card-line',
    color: 'bg-violet-50 border-violet-200',
    iconColor: 'text-violet-600 bg-violet-100',
    tag: 'Partenaire financier',
    tagColor: 'bg-violet-100 text-violet-700',
    title: 'Financement Sofinco',
    amount: 'Jusqu\'à 75 000 €',
    desc: 'Grâce à notre partenaire Sofinco, financez vos travaux en mensualités adaptées à votre budget. Réponse rapide, sans avance de fonds.',
    conditions: ['Jusqu\'à 84 mois de remboursement', 'Taux compétitifs', 'Réponse sous 48h', 'Cumulable avec les aides de l\'État'],
    link: '#contact'
  },
];

export default function AidesSection() {
  const [projet, setProjet] = useState<Projet>('pac-air-eau');
  const [revenu, setRevenu] = useState<Revenu>('modeste');
  const [showResult, setShowResult] = useState(false);

  const result = SIMS[projet][revenu];
  const isPV = projet === 'photovoltaique';

  return (
    <section id="aides" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-amber-100 text-amber-600 text-sm font-bold px-4 py-1.5 rounded-full mb-4">Aides de l'État</span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-slate-900 mb-4">
            Payez jusqu'à <span className="text-amber-500">70 % moins cher</span><br />grâce aux aides disponibles
          </h2>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            MaPrimeRénov', CEE, TVA réduite, financement Sofinco… On vous explique tout et on fait les démarches à votre place.
          </p>
        </div>

        {/* Aide cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
          {aides.map((aide, i) => (
            <div key={i} className={`border-2 ${aide.color} rounded-2xl p-6 flex flex-col`}>
              <div className="flex items-start justify-between mb-4">
                <div className={`w-12 h-12 ${aide.iconColor} rounded-xl flex items-center justify-center`}>
                  <i className={`${aide.logo} text-xl`}></i>
                </div>
                <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${aide.tagColor}`}>{aide.tag}</span>
              </div>
              <h3 className="font-extrabold text-slate-900 text-base mb-1">{aide.title}</h3>
              <p className="text-2xl font-black text-slate-800 mb-3">{aide.amount}</p>
              <p className="text-slate-500 text-sm leading-relaxed mb-4 flex-1">{aide.desc}</p>
              <ul className="space-y-1.5 mb-5">
                {aide.conditions.map((c, j) => (
                  <li key={j} className="flex items-center gap-2 text-xs text-slate-600">
                    <i className="ri-check-line text-emerald-500 flex-shrink-0"></i>
                    {c}
                  </li>
                ))}
              </ul>
              <a
                href={aide.link}
                target={aide.link.startsWith('http') ? '_blank' : undefined}
                rel="noopener noreferrer"
                className="text-sm font-semibold text-slate-600 hover:text-slate-900 flex items-center gap-1 transition-colors cursor-pointer mt-auto"
              >
                En savoir plus <i className="ri-arrow-right-s-line text-base"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Sofinco banner */}
        <div className="bg-gradient-to-r from-violet-50 to-violet-100 border-2 border-violet-200 rounded-2xl p-6 flex flex-col lg:flex-row items-center justify-between gap-6 mb-20">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 bg-violet-500 rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-bank-card-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="font-extrabold text-violet-900 text-lg">Financement disponible avec notre partenaire <span className="text-violet-600">Sofinco</span></p>
              <p className="text-violet-700 text-sm mt-0.5">Financez vos travaux en mensualités adaptées. Pas d'avance de fonds, réponse rapide. Cumulable avec toutes les aides de l'État.</p>
            </div>
          </div>
          <a
            href="#contact"
            className="bg-violet-600 hover:bg-violet-700 text-white font-bold px-7 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            Je me renseigne
          </a>
        </div>

        {/* Simulator */}
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl overflow-hidden">
          <div className="grid lg:grid-cols-2">
            {/* Left — form */}
            <div className="p-8 lg:p-12">
              <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/30 text-amber-300 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
                <i className="ri-calculator-line"></i>
                Simulateur de primes
              </div>
              <h3 className="text-3xl font-extrabold text-white mb-2">
                Estimez vos aides en 30 secondes
              </h3>
              <p className="text-slate-400 mb-8">
                Renseignez votre projet et vos revenus pour obtenir une estimation immédiate.
              </p>

              <div className="space-y-5">
                {/* Projet */}
                <div>
                  <label className="block text-sm font-semibold text-slate-300 mb-2">Votre projet</label>
                  <div className="grid grid-cols-2 gap-2">
                    {(Object.keys(projetLabels) as Projet[]).map(p => (
                      <button
                        key={p}
                        onClick={() => { setProjet(p); setShowResult(false); }}
                        className={`flex items-center gap-2 text-left px-4 py-3 rounded-xl text-sm font-medium transition-all cursor-pointer ${
                          projet === p
                            ? 'bg-amber-500 text-white'
                            : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
                        }`}
                      >
                        <i className={`${projetIcons[p]} text-sm flex-shrink-0`}></i>
                        {projetLabels[p]}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Revenus */}
                <div>
                  <label className="block text-sm font-semibold text-slate-300 mb-2">Tranche de revenus (foyer fiscal)</label>
                  <div className="space-y-2">
                    {(Object.keys(revenuLabels) as Revenu[]).map(r => (
                      <button
                        key={r}
                        onClick={() => { setRevenu(r); setShowResult(false); }}
                        className={`w-full text-left px-4 py-3 rounded-xl text-sm font-medium transition-all cursor-pointer ${
                          revenu === r
                            ? 'bg-amber-500 text-white'
                            : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
                        }`}
                      >
                        {revenuLabels[r]}
                      </button>
                    ))}
                  </div>
                </div>

                <button
                  onClick={() => setShowResult(true)}
                  className="w-full bg-amber-500 hover:bg-amber-600 text-white font-extrabold py-4 px-6 rounded-xl transition-colors cursor-pointer text-base"
                >
                  <i className="ri-calculator-line mr-2"></i>Calculer mes aides
                </button>
              </div>
            </div>

            {/* Right — result */}
            <div className="bg-slate-800/50 p-8 lg:p-12 flex flex-col justify-center">
              {!showResult ? (
                <div className="text-center">
                  <div className="w-20 h-20 bg-slate-700 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-pie-chart-2-line text-slate-400 text-3xl"></i>
                  </div>
                  <p className="text-slate-400 text-lg">Renseignez votre projet et vos revenus, puis cliquez sur <strong className="text-white">Calculer</strong>.</p>
                </div>
              ) : (
                <div>
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-white text-xl"></i>
                    </div>
                    <div>
                      <p className="text-white font-extrabold text-lg">Votre estimation</p>
                      <p className="text-slate-400 text-sm">{projetLabels[projet]}</p>
                    </div>
                  </div>

                  {isPV ? (
                    <div className="bg-amber-500/20 border border-amber-400/30 rounded-2xl p-6 mb-6">
                      <div className="flex items-start gap-3">
                        <i className="ri-sun-line text-amber-400 text-2xl flex-shrink-0 mt-0.5"></i>
                        <div>
                          <p className="text-white font-bold mb-2">Panneaux solaires — Avantages spécifiques</p>
                          <ul className="space-y-2 text-sm text-amber-200">
                            <li className="flex items-center gap-2"><i className="ri-check-line text-amber-400"></i>TVA réduite à <strong>10 %</strong> sur fourniture &amp; pose</li>
                            <li className="flex items-center gap-2"><i className="ri-check-line text-amber-400"></i>Prime à l'autoconsommation : <strong>300 – 1 000 €/kWc</strong> (EDF OA)</li>
                            <li className="flex items-center gap-2"><i className="ri-check-line text-amber-400"></i>Revente du surplus EDF</li>
                            <li className="flex items-center gap-2"><i className="ri-check-line text-amber-400"></i>Financement Sofinco disponible</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-3 mb-6">
                      <div className="bg-slate-700/60 rounded-2xl p-4 flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <i className="ri-government-line text-orange-400"></i>
                          <span className="text-slate-300 text-sm font-medium">MaPrimeRénov'</span>
                        </div>
                        <span className="text-white font-bold text-lg">
                          {result.maPrimeRenov > 0 ? `${result.maPrimeRenov.toLocaleString('fr-FR')} €` : 'Non éligible'}
                        </span>
                      </div>
                      <div className="bg-slate-700/60 rounded-2xl p-4 flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <i className="ri-flashlight-line text-teal-400"></i>
                          <span className="text-slate-300 text-sm font-medium">Prime CEE</span>
                        </div>
                        <span className="text-white font-bold text-lg">
                          {result.cee > 0 ? `${result.cee.toLocaleString('fr-FR')} €` : 'N/A'}
                        </span>
                      </div>
                      <div className="bg-slate-700/60 rounded-2xl p-4 flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <i className="ri-percent-line text-emerald-400"></i>
                          <span className="text-slate-300 text-sm font-medium">TVA réduite</span>
                        </div>
                        <span className="text-emerald-400 font-bold text-lg">{result.tva}</span>
                      </div>
                      <div className="bg-slate-700/60 rounded-2xl p-4 flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <i className="ri-bank-card-line text-violet-400"></i>
                          <span className="text-slate-300 text-sm font-medium">Financement Sofinco</span>
                        </div>
                        <span className="text-violet-400 font-bold text-sm">Disponible</span>
                      </div>
                    </div>
                  )}

                  {!isPV && result.total > 0 && (
                    <div className="bg-amber-500 rounded-2xl p-6 text-center mb-4">
                      <p className="text-amber-100 text-sm font-medium mb-1">Total des aides estimées</p>
                      <p className="text-white text-4xl font-black">{result.total.toLocaleString('fr-FR')} €</p>
                    </div>
                  )}

                  <p className="text-slate-500 text-xs leading-relaxed mb-5">{result.note}</p>

                  <a
                    href="#contact"
                    className="w-full flex items-center justify-center gap-2 bg-white text-slate-900 hover:bg-slate-100 font-extrabold py-4 px-6 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-send-plane-fill"></i>Obtenir mon devis personnalisé
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Bottom note */}
        <div className="mt-8 flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-2xl p-5">
          <i className="ri-information-line text-amber-500 text-xl flex-shrink-0 mt-0.5"></i>
          <p className="text-amber-800 text-sm leading-relaxed">
            <strong>Important :</strong> Les montants affichés sont des estimations indicatives basées sur les barèmes 2024 de l'ANAH et des organismes CEE. Le montant réel dépend de plusieurs critères (revenus du foyer, localisation, type de travaux). Nos conseillers AIRPURE vous accompagnent gratuitement pour maximiser vos aides. Le financement Sofinco est soumis à acceptation par l'organisme prêteur.
          </p>
        </div>
      </div>
    </section>
  );
}
